import {validDateKey} from './activity-model.js';
import {routeRange} from './route-range.js';
import {ARCHIVE_EVENT_TYPES} from './archive-model.js';
export const BROWSER_VIEWS=['overview','map','alarms','care','events','activity','device'];
const keys=['view','screen','device','from','to','filter','basis'];
export function parseBrowserNavigation(href){
 const url=new URL(href,'https://local.invalid'),q=url.searchParams;
 const view=q.get('view')??'overview',screen=q.get('screen'),device=q.get('device');
 const invalid=!BROWSER_VIEWS.includes(view)||Boolean(screen&&!/^(?:[a-z][a-z0-9-]{1,79}|event:[1-9][0-9]*)$/.test(screen))||Boolean(device&&!/^[A-Za-z0-9_-]{4,32}$/.test(device));
 const start=q.get('from'),end=q.get('to')??start,filter=q.get('filter'),basis=q.get('basis');
 return {view:invalid?'overview':view,screen:invalid?null:screen,device:invalid?null:device,invalid,
  ...(validDateKey(start)&&routeRange(start,end)?{start,end}:{}),
  ...(['pending','handled',...ARCHIVE_EVENT_TYPES].includes(filter)?{filter}:{}),...(basis==='receipt'||basis==='measured'?{basis}:{} )};
}
export function browserNavigation(){return typeof window==='undefined'||!window.location?.href?parseBrowserNavigation('https://local.invalid'):parseBrowserNavigation(window.location.href);}
export function writeBrowserNavigation(value,owner,replace=false){
 if(typeof window==='undefined'||!window.location?.href||!window.history)return;
 const url=new URL(window.location.href);for(const key of keys)url.searchParams.delete(key);
 const fields={view:value.view,screen:value.screen,device:value.device,from:value.start,to:value.end,filter:value.filter,basis:value.basis};
 for(const [key,val] of Object.entries(fields))if(val!=null)url.searchParams.set(key,String(val));
 const state={...window.history.state,qtrackerOwner:owner};
 window.history[replace?'replaceState':'pushState'](state,'',url);
}
export function browserDeviceSelected(device,owner){writeBrowserNavigation({view:'overview',device},owner);}
